import type { ImportSessionViewProps } from "@/ui/view-props";
import { ImportSessionClassicView } from "@/ui/v1/ImportSessionClassicView";
import { cn } from "@/lib/utils";

const STEPS = ["Input", "Review", "Confirm"];

export function ImportSessionModernView(p: ImportSessionViewProps) {
  return (
    <div className="space-y-5 animate-fade-in">
      {/* Step indicator */}
      <div className="flex items-center gap-0">
        {STEPS.map((label, i) => {
          const stepNum = i + 1;
          const isActive = stepNum === p.step;
          const isDone = stepNum < p.step;
          return (
            <div key={label} className="flex items-center flex-1 last:flex-none">
              <div className="flex flex-col items-center gap-1 shrink-0">
                <div className={cn(
                  "w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-colors",
                  isActive && "bg-primary text-primary-foreground shadow-card",
                  isDone && "bg-success/20 text-success border border-success/30",
                  !isActive && !isDone && "bg-muted text-muted-foreground",
                )}>
                  {isDone ? "✓" : stepNum}
                </div>
                <span className={cn(
                  "text-[10px] font-semibold whitespace-nowrap",
                  isActive ? "text-primary" : isDone ? "text-success" : "text-muted-foreground",
                )}>
                  {label}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div className={cn(
                  "h-px flex-1 mx-2 mb-4 transition-colors",
                  isDone ? "bg-success/40" : "bg-border",
                )} />
              )}
            </div>
          );
        })}
      </div>

      <ImportSessionClassicView {...p} />
    </div>
  );
}
